"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
const http = __importStar(require("http"));
const https = __importStar(require("https"));
const url = __importStar(require("url"));
const events_1 = require("events");
class EventStream extends events_1.EventEmitter {
    constructor(uri = '', token = '') {
        super();
        this.uri = uri;
        this.token = token;
        this.reconnectInterval = 2000;
        this.timeout = 13000;
        this.data = '';
        this.buf = '';
        this.parse = this.parse.bind(this);
        this.end = this.end.bind(this);
        this.idleTimeoutExpired = this.idleTimeoutExpired.bind(this);
    }
    connect() {
        return new Promise((resolve, reject) => {
            const parsed = url.parse(this.uri);
            const { hostname, protocol, port, path } = parsed;
            this.origin = `${protocol}//${hostname}${port ? (':' + port) : ''}`;
            const isSecure = protocol === 'https:';
            const requestor = isSecure ? https : http;
            const nonce = typeof performance !== 'undefined' ? performance.now() : 0;
            const req = requestor.request({
                hostname,
                protocol,
                path: `${path}?nonce=${nonce}`,
                headers: {
                    'Authorization': `Bearer ${this.token}`
                },
                method: 'get',
                port: parseInt(port !== null && port !== void 0 ? port : '', 10) || (isSecure ? 443 : 80),
                mode: 'prefer-streaming'
            });
            this.req = req;
            let connected = false;
            const connectionTimeout = setTimeout(() => {
                if (this.req) {
                    this.req.destroy();
                }
                reject({ error: new Error('Timeout'), errorDescription: `Timeout connecting to ${this.uri}` });
            }, this.timeout);
            req.on('error', (e) => {
                clearTimeout(connectionTimeout);
                if (connected) {
                    this.end();
                }
                else {
                    reject({ error: e, errorDescription: `Network error from ${this.uri}` });
                }
            });
            req.on('response', (res) => {
                clearTimeout(connectionTimeout);
                const statusCode = res.statusCode;
                if (statusCode !== 200) {
                    let body = '';
                    res.on('data', (chunk) => body += chunk.toString());
                    res.on('end', () => {
                        try {
                            body = JSON.parse(body);
                        }
                        catch (_err) {
                            // ignore
                        }
                        finally {
                            let errorDescription = `HTTP error ${statusCode} from ${this.uri}`;
                            if (body && typeof body === 'object' && 'error_description' in body) {
                                errorDescription += ' - ' + body.error_description;
                            }
                            reject({ statusCode, errorDescription, body });
                            this.req = undefined;
                        }
                    });
                    return;
                }
                this.data = '';
                this.buf = '';
                connected = true;
                res.on('data', this.parse);
                res.once('end', this.end);
                this.startIdleTimeout();
                resolve(this);
            });
            req.end();
        });
    }
    abort() {
        if (this.req) {
            this.req.destroy();
            this.req = undefined;
        }
        this.removeAllListeners();
    }
    emitSafe(event, param) {
        try {
            this.emit(event, param);
        }
        catch (error) {
            if (event !== 'error') {
                this.emitSafe('error', error);
            }
        }
    }
    end() {
        this.stopIdleTimeout();
        if (!this.req) {
            return;
        }
        this.req = undefined;
        this.emitSafe('disconnect');
        this.reconnect();
    }
    reconnect() {
        setTimeout(() => {
            if (this.isOffline()) {
                this.reconnect();
                return;
            }
            this.emitSafe('reconnect');
            this.connect().then(() => {
                this.emitSafe('reconnect-success');
            }).catch((err) => {
                this.emitSafe('reconnect-error', err);
                this.reconnect();
            });
        }, this.reconnectInterval);
    }
    isOffline() {
        if (typeof navigator === 'undefined' || Object.hasOwnProperty.call(navigator, 'onLine')) {
            return false;
        }
        return !navigator.onLine;
    }
    startIdleTimeout() {
        this.stopIdleTimeout();
        this.idleTimeout = setTimeout(this.idleTimeoutExpired, this.timeout);
    }
    stopIdleTimeout() {
        if (this.idleTimeout) {
            clearTimeout(this.idleTimeout);
            this.idleTimeout = null;
        }
    }
    idleTimeoutExpired() {
        if (this.req) {
            this.req.destroy();
            this.end();
        }
    }
    parse(chunk) {
        this.startIdleTimeout();
        this.buf += chunk.toString();
        let pos = 0;
        const length = this.buf.length;
        let discardTrailingNewline = false;
        while (pos < length) {
            if (discardTrailingNewline) {
                if (this.buf[pos] === '\n') {
                    ++pos;
                }
                discardTrailingNewline = false;
            }
            let lineLength = -1;
            let fieldLength = -1;
            for (let i = pos; lineLength < 0 && i < length; ++i) {
                const c = this.buf[i];
                if (c === ':') {
                    if (fieldLength < 0) {
                        fieldLength = i - pos;
                    }
                }
                else if (c === '\r') {
                    discardTrailingNewline = true;
                    lineLength = i - pos;
                }
                else if (c === '\n') {
                    lineLength = i - pos;
                }
            }
            if (lineLength < 0) {
                break;
            }
            this.parseEventStreamLine(pos, fieldLength, lineLength);
            pos += lineLength + 1;
        }
        if (pos === length) {
            this.buf = '';
        }
        else if (pos > 0) {
            this.buf = this.buf.slice(pos);
        }
    }
    parseEventStreamLine(pos, fieldLength, lineLength) {
        if (lineLength === 0) {
            try {
                if (this.data.length > 0 && this.event) {
                    const event = JSON.parse(this.data);
                    event.name = this.eventName || '';
                    this.emitSafe('event', event);
                }
            }
            catch (_err) {
                // ignore
            }
            finally {
                this.data = '';
                this.eventName = undefined;
                this.event = false;
            }
        }
        else if (fieldLength > 0) {
            const field = this.buf.slice(pos, pos + fieldLength);
            let step = 0;
            if (this.buf[pos + fieldLength + 1] !== ' ') {
                step = fieldLength + 1;
            }
            else {
                step = fieldLength + 2;
            }
            pos += step;
            const valueLength = lineLength - step;
            const value = this.buf.slice(pos, pos + valueLength);
            if (field === 'data') {
                this.data += value + '\n';
            }
            else if (field === 'event') {
                this.eventName = value;
                this.event = true;
            }
        }
    }
}
module.exports = EventStream;
//# sourceMappingURL=EventStream.js.map